<template>
    <div class="container-fluid">
        <ul class="AdminDoctorSettingsBread d-flex align-items-center">
            <li><a href="/admin/doctors">医師一覧</a></li>
            <li>医師設定</li>
        </ul>

        <b-card no-body>
            <b-tabs card>
                <b-tab>
                    <template v-slot:title>{{ $locale.consultation_host }}メニュー</template>
                    <admin-doctor-menus :doctor="doctor"/>
                </b-tab>
                <b-tab>
                    <template v-slot:title>{{ $locale.question }}</template>
                    <b-container>
                        <settings-interview-question
                            :doctor="doctor"
                            user-type="admin">
                        </settings-interview-question>
                    </b-container>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
    import constants from '../../constants'
    import YokumiruHelper from '../../YokumiruHelper'

    export default {
        props: {
            doctor: {
                type: Object,
                required: true,
            },
        },

        data: function() {
            return {
                helper: YokumiruHelper,
            }
        },

        created: function () {},

        beforeDestroy: function () {},

        methods: {},
    };
</script>

<style lang="scss" scoped>
.AdminDoctorSettingsBread {
    margin-left: 0;
    padding-left: 4px;

    li {
        color: #828B92;
        list-style: none;

        &::after {
            content: '>';
            position: relative;
            top: -1px;
            margin: 0 7px;
            font-size: 12px;
        }

        &:last-child::after {
            content: '';
            margin: 0;
        }
    }
}
</style>
